<template>
  <div>

    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="列表" name="MeterFeeTagList">
        <MeterFeeTagList  v-if="card_index==='MeterFeeTagList'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MeterFeeTagList from "./MeterFeeTagList";

export default {
  name: "MeterFeeTagMain",
  components: {MeterFeeTagList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"MeterFeeTagList"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_fee_tag/MeterFeeTagMain.vue